<!-- ================管理端-概览====================-->
<template>
    <div class="admin-screen-container overview-container">
        <div class="overview-box-container">
            <div class="overview-logo-container">
                <img class="img-100" src="../../../assets/logo/logo.png" alt="博雅美育五馆">
            </div>
            <div class="overview-slogan-container">博雅美育浸润·五馆合一</div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    name: "overview",
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {},
    methods: {

    },
}
</script>
<style>
.overview-container{
    display: flex;
    align-items: center;
    justify-content: center;
}
.overview-box-container{
    width: auto;
    height: 44px;
    display: flex;
}
.overview-logo-container{
    width: 44px;
    height: 44px;
}
.overview-slogan-container{
    height: 44px;
    display: flex;
    padding-left: 6px;
    box-sizing: border-box;
    font-weight: bold;
    font-size: 16px;
    line-height: 44px;
    font-family: sans-serif;
    color: #377f7f;
}
</style>